import React from 'react'
import ApartmentDashbaord from '../../features/apartment/ApartmentDashbaord'

const ApartmentDashPage = () => {
  return <ApartmentDashbaord/>
}

export default ApartmentDashPage